// A spruce: a tall, NARROW conifer — four slim stacked cones in a cool
// blue-green, more spire-like than the pine. Ported 1:1 from age-of-mcp's
// classic tree-spruce.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.05, 0.08, 0.26, 5),
      color: "#43301f", position: [0, 0.13, 0] },
    { geometry: new THREE.ConeGeometry(0.4, 0.7, 6),
      color: "#27583f", position: [0, 0.55, 0] },
    { geometry: new THREE.ConeGeometry(0.31, 0.66, 6),
      color: "#2d6347", position: [0, 0.95, 0] },
    { geometry: new THREE.ConeGeometry(0.22, 0.62, 6),
      color: "#356f50", position: [0, 1.34, 0] },
    { geometry: new THREE.ConeGeometry(0.13, 0.56, 6),
      color: "#3e7d59", position: [0, 1.72, 0] },
  ];
}

export const treeSpruce = defineModel({
  id: "tree-spruce",
  batchId: "standard",
  name: "Tree spruce",
  tags: ["scenery","tree","spruce","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree spruce.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => partsFor(),
  animations: [],
});
